module.exports = __webpack_public_path__ + "img/Sylva_island_treasure.2abb43ec.png";